// src/components/Dashboard.js
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {
  List,
  ListItem,
  ListItemText,
  Card,
  CardContent,
  Typography,
  Button,
  ListItemIcon,
} from "@mui/material";
import { motion } from "framer-motion";
import Nav from "./Nav";
import styles from "./Dashbrd.module.css";

// Import Arrow Icons for Toggle Button
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

// Import images for cards
import universalImg from "../../asset/dashb/universal.png";
import cocImg from "../../asset/dashb/codeofconduct.png";
import taxImg from "../../asset/dashb/taxImg.png";

// Import Material-UI icons
import PublicIcon from '@mui/icons-material/Public';
import GavelIcon from '@mui/icons-material/Gavel';


const Dashbrd = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const welcomeMessage = location.state?.welcomeMessage;
  const username = location.state?.username;
  const [activeSection, setActiveSection] = useState("Universal");
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);

  useEffect(() => {
    if (welcomeMessage) {
      toast.success(welcomeMessage, {
        position: "top-center",
        autoClose: 2000,
      });
    }
  }, [welcomeMessage]);

  const handleDemoClick = (route) => {
    navigate(route);
  };

  const getCards = () => {
    switch (activeSection) {
      case "Universal":
        return (
          <CardComponent
            title="Universal AI"
            description="Explore AI solutions tailored for universal applications."
            logo={universalImg}
            onDemoClick={() => handleDemoClick("/demochat")}
          />
        );

        case "COC":
        return (
          <>
            <CardComponent
              title="Compliance"
              description="Maintain a respectful, collaborative, and inclusive workplace."
              logo={cocImg}
              onDemoClick={() => handleDemoClick("/compliance")}
            />
            <CardComponent
              title="Income Tax Department"
              description="Manage your income tax documents and filings."
              logo={taxImg}
              onDemoClick={() => handleDemoClick("/demochat")}
            />
          </>
        );

        case "IncomeTax":
          return (
            <CardComponent
              title="Income Tax Department"
              description="Manage your income tax documents and filings."
              logo={taxImg}
              onDemoClick={() => handleDemoClick("/demochat")}
            />
          );

      default:
        return null;
    }
  };

  const CardComponent = ({ title, description, onDemoClick, logo }) => (
    <motion.div
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <Card className={styles.card}>
        <CardContent>
          {logo && (
            <img src={logo} alt={`${title} logo`} className={styles.cardLogo} />
          )}
          <Typography
            variant="h5"
            component="div"
            style={{}}
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            style={{ marginTop: "5px" }}
          >
            {description}
          </Typography>
          <Button
            variant="contained"
            color="inherit"
            onClick={onDemoClick}
            style={{ marginTop: "20px", textTransform: "none" }}
          >
            Try Demo
          </Button>
        </CardContent>
      </Card>
    </motion.div>
  );

  // Toggle function to expand or collapse the sidebar
  const toggleSidebar = () => {
    setIsSidebarExpanded(!isSidebarExpanded);
  };

  return (
    <div className={styles.dashboard}>
      <ToastContainer />
      <Nav username={username} />
      <div className={`${styles.sidebar} ${isSidebarExpanded ? styles.expanded : ""}`}>
      <List>
  <ListItem
    button
    onClick={() => setActiveSection("Universal")}
    className={activeSection === "Universal" ? styles.activeItem : ""}
  >
    <ListItemIcon className={styles.sidebarIcon}>
      <PublicIcon fontSize="inherit" />
    </ListItemIcon>
    {isSidebarExpanded && <ListItemText primary="Universal" />}
  </ListItem>
  <ListItem
    button
    onClick={() => setActiveSection("COC")}
    className={activeSection === "COC" ? styles.activeItem : ""}
  >
    <ListItemIcon className={styles.sidebarIcon}>
      <GavelIcon fontSize="inherit" />
    </ListItemIcon>
    {isSidebarExpanded && <ListItemText primary="Mebot POC" />}
  </ListItem>
</List>

        <div className={styles.toggleButton} onClick={toggleSidebar}>
          {isSidebarExpanded ? <ArrowBackIosIcon /> : <ArrowForwardIosIcon />}
        </div>
      </div>

      <div className={styles.content}>{getCards()}</div>
    </div>
  );
};

export default Dashbrd;